export const KYC_DECLINED_ANIMATION = {
  LOTTIE_INITIAL_Y: 36,
  LOTTIE_DELAY: 0.2,
  LOTTIE_DURATION: 0.45,
  TITLE_INITIAL_X: -18,
  TITLE_DURATION: 0.32,
  DESCRIPTION_INITIAL_X: -18,
  DESCRIPTION_DURATION: 0.32,
  TITLE_REVEAL_DELAY_MS: 120,
  DESCRIPTION_REVEAL_DELAY_MS: 320,
} as const;
